'use strict';

const INIT_LAST_ACCESSED_ORGANIZATIONS = '@@app-model/INIT_LAST_ACCESSED_ORGANIZATIONS';
const INIT_LAST_ACCESSED_PROJECTS = '@@app-model/INIT_LAST_ACCESSED_PROJECTS';
const INIT_LAST_ACCESSED_ASSETS = '@@app-model/INIT_LAST_ACCESSED_ASSETS';
const ADD_TO_LAST_ACCESSED_ORGANIZATIONS = '@@app-model/ADD_TO_LAST_ACCESSED_ORGANIZATIONS';
const ADD_TO_LAST_ACCESSED_PROJECTS = '@@app-model/ADD_TO_LAST_ACCESSED_PROJECTS';
const ADD_TO_LAST_ACCESSED_ASSETS = '@@app-model/ADD_TO_LAST_ACCESSED_ASSETS';
const REMOVE_FROM_LAST_ACCESSED_ORGANIZATIONS = '@@app-model/REMOVE_FROM_LAST_ACCESSED_ORGANIZATIONS';
const REMOVE_FROM_LAST_ACCESSED_PROJECTS = '@@app-model/REMOVE_FROM_LAST_ACCESSED_PROJECTS';
const REMOVE_FROM_LAST_ACCESSED_ASSETS = '@@app-model/REMOVE_FROM_LAST_ACCESSED_ASSETS';

/**
 * @typedef {Object} LastAccessedItem
 * @property {String} id
 * @property {String} label
 */

/**
 * @typedef {Array.<LastAccessedItem>} LastAccessedOrgStore
 */

/**
 * @typedef {Object.<String, Array.<LastAccessedItem>>} LastAccessedStore
 */

/**
 * The initial state of lastAccessedOrganizations, loaded from a cached source.
 * @param state
 * @return {ReduxAction.<LastAccessedOrgStore>}
 */
export function initLastAccessedOrganizations(state) {
  return {
    type: INIT_LAST_ACCESSED_ORGANIZATIONS,
    payload: {
      state,
    },
  };
}
initLastAccessedOrganizations.TYPE = INIT_LAST_ACCESSED_ORGANIZATIONS;

/**
 * The initial state of lastAccessedProjects, loaded from a cached source.
 * @param state
 * @return {ReduxAction.<LastAccessedStore>}
 */
export function initLastAccessedProjects(state) {
  return {
    type: INIT_LAST_ACCESSED_PROJECTS,
    payload: {
      state,
    },
  };
}
initLastAccessedProjects.TYPE = INIT_LAST_ACCESSED_PROJECTS;

/**
 * The initial state of lastAccessedAssets, loaded from a cached source.
 * @param state
 * @return {ReduxAction.<LastAccessedStore>}
 */
export function initLastAccessedAssets(state) {
  return {
    type: INIT_LAST_ACCESSED_ASSETS,
    payload: {
      state,
    },
  };
}
initLastAccessedAssets.TYPE = INIT_LAST_ACCESSED_ASSETS;

/**
 *
 * @param {?LastAccessedItem} data
 * @return {ReduxAction}
 */
export function addToLastAccessedOrganizations(data) {
  return {
    type: ADD_TO_LAST_ACCESSED_ORGANIZATIONS,
    payload: {
      data,
    },
  };
}
addToLastAccessedOrganizations.TYPE = ADD_TO_LAST_ACCESSED_ORGANIZATIONS;

/**
 *
 * @param {String} orgId
 * @param {?LastAccessedItem} data
 * @return {ReduxAction}
 */
export function addToLastAccessedProjects(orgId, data) {
  return {
    type: ADD_TO_LAST_ACCESSED_PROJECTS,
    payload: {
      orgId,
      data,
    },
  };
}
addToLastAccessedProjects.TYPE = ADD_TO_LAST_ACCESSED_PROJECTS;

/**
 *
 * @param {String} orgId
 * @param {?LastAccessedItem} data
 * @return {ReduxAction}
 */
export function addToLastAccessedAssets(orgId, data) {
  return {
    type: ADD_TO_LAST_ACCESSED_ASSETS,
    payload: {
      orgId,
      data,
    },
  };
}
addToLastAccessedAssets.TYPE = ADD_TO_LAST_ACCESSED_ASSETS;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function removeFromLastAccessedOrganizations(id) {
  return {
    type: REMOVE_FROM_LAST_ACCESSED_ORGANIZATIONS,
    payload: {
      id,
    },
  };
}
removeFromLastAccessedOrganizations.TYPE = REMOVE_FROM_LAST_ACCESSED_ORGANIZATIONS;

/**
 *
 * @param {String} orgId
 * @param {String} id
 * @return {ReduxAction}
 */
export function removeFromLastAccessedProjects(orgId, id) {
  return {
    type: REMOVE_FROM_LAST_ACCESSED_PROJECTS,
    payload: {
      orgId,
      id,
    },
  };
}
removeFromLastAccessedProjects.TYPE = REMOVE_FROM_LAST_ACCESSED_PROJECTS;

/**
 *
 * @param {String} orgId
 * @param {String} id
 * @return {ReduxAction}
 */
export function removeFromLastAccessedAssets(orgId, id) {
  return {
    type: REMOVE_FROM_LAST_ACCESSED_ASSETS,
    payload: {
      orgId,
      id,
    },
  };
}
removeFromLastAccessedAssets.TYPE = REMOVE_FROM_LAST_ACCESSED_ASSETS;



// WEBPACK FOOTER //
// ./src/js/app/model/actions/lastAccessed.js